<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        label: '',
        type: 'VARCHAR',
        required: false,
      }),
      require: false,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
    typeOptions: {
      type: Array,
      default: [],
      require: false,
    },
  },
  computed: {
    dataCustomField: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormCutomField.validate();
      if (isValid) {
        this.$emit('ok', this.dataCustomField);
        this.$bvModal.hide(this.idModal);
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataCustomField.isDefault || dataCustomField.label === '' || dataCustomField.type === null"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormCutomField">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              md="6"
              class="mb-1"
          >
            <b-form-group
                label="Nome do campo *"
                label-for="name-custom-field"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Nome do campo"
                  rules="required"
              >
                <b-form-input
                    v-model="dataCustomField.label"
                    id="name-custom-field"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Campo"
                    :disabled="dataCustomField.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
                label="Tipo do campo *"
                label-for="type-custom-field"
            >
              <template #label>
                <span>Tipo do campo *</span>
                <b-alert
                    show
                    variant="warning"
                    class="mb-0"
                    style="padding: 10px;"
                >
                  <small class="font-weight-bold">Atenção: </small>
                  <small>Após a criação do campo, não será possível alterar o tipo.</small>
                </b-alert>
              </template>
              <v-select
                  id="type-custom-field"
                  placeholder="Selecione um tipo"
                  v-model="dataCustomField.type"
                  :options="typeOptions"
                  label="label"
                  :reduce="option => option.value"
                  :disabled="dataCustomField.isDefault || dataCustomField.id !== null"
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <div class="px-auto">
              <p class="font-weight-bold">Regras de qualidade</p>
            </div>

            <div class="row align-items-center px-1">
              <b-form-checkbox
                  v-model="dataCustomField.required"
                  :checked="true"
                  :unchecked-value="false"
                  class="custom-control-success"
                  name="check-button"
                  :disabled="dataCustomField.isDefault"
                  switch
              />
              <b-card-text class="mb-0">
                Obrigatório
              </b-card-text>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
